// extracted by mini-css-extract-plugin
export default {"root":"GU5jbc","mobile":"pvZ7uo","disablePadding":"edZmmc","disabled":"xaaQpQ"};